<template>
    <div class="px-3 py-2">
        <v-form
            ref="forcar"
            lazy-validation
        >
            <b-sidebar id="add_new_product" aria-labelledby="sidebar-no-header-title" no-header backdrop width="50%" style="direction:ltr;padding:5px;" right title="اضافة منتج" shadow >
                <template #default="{ hide }" >
                <div class="m-1 text-start" style="direction:rtl;margin:5px;">
                    <div style="width:130px;margin-right:10px;background:#000;color:#FFF;border-radius:5px" class="btn-primary btn-sm text-center">
                    <span>{{lang.add_edit_product}}</span>
                    </div>
                    <div @click="hide" id="hidecrmprodaddedit" style="text-align:center;width:100px;float:left;margin-left:5px;margin-top:-25px;cursor:pointer" class="btn-danger btn-sm">
                    <span>{{lang.close}}</span>
                </div>
                </div>
                <v-divider></v-divider>
                <v-row style="direction:rtl;margin:5px;" class="m-2">
                    <v-col cols="12" md="3" sm="12">
                        <label>{{lang.item_code}}</label>
                        <b-input-group>
                            <b-form-input class="inborder"
                                v-model="product.item_code"
                                @change="getItem()"
                                ></b-form-input>
                            <!-- The code is filled in automatically for a new
                                 item; this re-rolls it if the user wants. -->
                            <b-input-group-append v-if="isEdit == 0">
                                <b-button
                                    size="sm"
                                    variant="outline-secondary"
                                    :title="productLabels.generate_code"
                                    style="padding:0 8px;"
                                    @click="generateItemCode(true)"
                                ><i class="fas fa-sync"></i></b-button>
                            </b-input-group-append>
                        </b-input-group>
                    </v-col>
                    <v-col cols="12" md="3" sm="12">
                        <label>{{lang.vendor_code}}</label>
                        <b-form-input class="inborder"
                            v-model="product.vendor_code"
                            ></b-form-input>
                    </v-col>
                    <v-col cols="12" md="3" sm="12" class="select_box">
                        <label>{{lang.is_finalProduct}}</label>
                        <b-input-group>
                            <b-form-select class="selborder"
                            style="width:200px !important"
                            v-model="product.is_finalProduct"
                            :options="isFinal"
                            ></b-form-select>
                        </b-input-group>
                    </v-col>
                    <v-col cols="12" md="3" sm="12" class="select_box">
                        <label>{{lang.is_saleable}}</label>
                        <b-input-group>

                            <b-form-select class="selborder"
                            style="width:200px !important"
                            v-model="product.saleable"
                            :options="saleAbles"
                            >
                            </b-form-select>
                        </b-input-group>
                    </v-col>
                    <v-col cols="12" md="4" sm="12">
                        <label>{{lang.product_namear}}</label>
                        <b-form-input class="inborder"
                            v-model="product.item_namear"
                            ></b-form-input>
                    </v-col>
                  <v-col cols="12" md="4" sm="12">
                    <label>{{lang.product_nameen}}</label>
                    <b-form-input class="inborder"
                        v-model="product.item_nameen"
                    ></b-form-input>
                  </v-col>
                    <v-col cols="12" md="4" sm="12">
                        <label>{{productLabels.internal_code}}</label>
                        <b-form-input class="inborder"
                            v-model="product.internal_code"
                            ></b-form-input>
                    </v-col>
                    <v-col cols="12" md="4" sm="12">
                        <label>{{productLabels.barcode}}</label>
                        <b-form-input class="inborder"
                            v-model="product.barcode"
                            ></b-form-input>
                    </v-col>
                    <v-col cols="12" md="4" sm="12">
                        <label>{{productLabels.brand_name}}</label>
                        <b-form-input class="inborder"
                            v-model="product.brand_name"
                            ></b-form-input>
                    </v-col>
                    <v-col cols="12" md="4" sm="12">
                        <label>MPN</label>
                        <b-form-input class="inborder"
                            v-model="product.mpn"
                            ></b-form-input>
                    </v-col>
                    <v-col cols="12" md="4" sm="12">
                        <label>GTIN</label>
                        <b-form-input class="inborder"
                            v-model="product.gtin"
                            ></b-form-input>
                    </v-col>
                    <v-col cols="12" md="4" sm="12">
                        <label>{{productLabels.source_product_no}}</label>
                        <b-form-input class="inborder"
                            v-model="product.source_product_no"
                            ></b-form-input>
                    </v-col>

                    <v-col cols="12" md="4" sm="12">
                        <label>{{lang.product_category}}</label>
                        <!-- Searched on the server: the category list runs to
                             thousands of rows and cannot be a plain select. -->
                        <searchable-select
                            v-model="product.catid"
                            :items="categories"
                            :selected-text="categoryText"
                            :loading="loadingCats"
                            :placeholder="productLabels.type_to_search"
                            :loading-text="productLabels.searching"
                            :empty-text="productLabels.no_results"
                            :hint="categoryHint"
                            @search="searchCategories"
                            @picked="onCategoryPicked"
                        />
                    </v-col>
                    <v-col cols="12" md="4" sm="12">
                        <label>{{lang.product_type}}</label>
                        <b-input-group>
                            <b-form-select class="selborder"
                            style="width:200px !important"
                            v-model="product.item_type"
                            :options="productstype"
                            ></b-form-select>
                            <b-input-group-append style="margin-right:-20px;margin-top:5px;">
                            <i class="fas fa-arrow-down" style="z-index:"></i>
                            </b-input-group-append>
                        </b-input-group>
                    </v-col>
                    <v-col cols="12" md="4" sm="12">
                        <label>{{lang.main_unit}}</label>
                        <b-input-group>
                            <b-form-select class="selborder"
                            style="width:200px !important"
                            v-model="product.main_unit"
                            :options="mainUnits"
                            ></b-form-select>
                            <b-input-group-append style="margin-right:-20px;margin-top:5px;">
                            <i class="fas fa-arrow-down" style="z-index:"></i>
                            </b-input-group-append>
                        </b-input-group>
                    </v-col>
                    <v-col cols="12" md="12" sm="12">
                        <label>{{productLabels.def_descriptions}}</label>
                        <b-form-textarea class="inborder"
                            v-model="product.def_descriptions"
                            ></b-form-textarea>
                    </v-col>
                </v-row>
                <v-row style="direction:rtl;padding:2px;">
                    <v-col cols="12" md="4" sm="12">
                        <label>{{lang.taxes}}</label>
                        <b-input-group>
                            <b-form-select class="selborder"
                            style="width:200px !important;background:blue !important;"
                            v-model="product.taxesArrays"
                            :options="taxesIList"
                            multiple
                            ></b-form-select>
                            <b-input-group-append style="margin-right:-20px;margin-top:5px;">
                            <i class="fas fa-arrow-down" style="z-index:"></i>
                            </b-input-group-append>
                        </b-input-group>

                    </v-col>
                    <v-col cols="12" md="4" sm="12">
                        <label>{{lang.stores}}</label>
                        <b-input-group>
                            <b-form-select class="selborder"
                            style="width:200px !important;background:blue !important;"
                            v-model="product.storesids_array"
                            :options="storesIList"
                            multiple
                            ></b-form-select>
                            <b-input-group-append style="margin-right:-20px;margin-top:5px;">
                            <i class="fas fa-arrow-down" style="z-index:"></i>
                            </b-input-group-append>
                        </b-input-group>

                    </v-col>
                    <v-col cols="12" md="4" sm="12">
                        <label>{{lang.branches}}</label>
                        <b-input-group>
                            <b-form-select class="selborder"
                            style="width:200px !important;background:blue !important;"
                            v-model="product.branches_array"
                            :options="branchesIList"
                            multiple
                            ></b-form-select>
                            <b-input-group-append style="margin-right:-20px;margin-top:5px;">
                            <i class="fas fa-arrow-down" style="z-index:"></i>
                            </b-input-group-append>
                        </b-input-group>

                    </v-col>
                </v-row>
                <v-row style="direction:rtl;padding:2px;">
                    <v-col cols="12" v-if="product.saleable == 1">
                        <v-simple-table>
                            <thead>
                                <tr>
                                    <th class="backBlack">{{lang.unit_name}}</th>
                                    <th class="backBlack">{{lang.sale_price}}</th>
                                    <th class="backBlack">{{ lang.minimum_salse_price }}</th>
                                    <th class="backBlack">{{ lang.maximum_salse_price }}</th>
                                    <th class="backBlack">{{lang.default_cost}}</th>
                                    <th v-if="product.id != 0"  class="backBlack">{{lang.update}}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item,index) in unitsPrices[product.main_unit]" :key="index">
                                    <td>{{ item[`name${lang.langname}`] }}</td>
                                    <td><b-form-input class="inborder" v-model="unitsPrices[product.main_unit][index].default_price" /></td>
                                    <td><b-form-input class="inborder" v-model="unitsPrices[product.main_unit][index].min_price" /></td>
                                    <td><b-form-input class="inborder" v-model="unitsPrices[product.main_unit][index].max_price" /></td>
                                    <td><b-form-input class="inborder" v-model="unitsPrices[product.main_unit][index].cost" /></td>
                                    <td v-if="product.id != 0" @click="updateThis(unitsPrices[product.main_unit][index])" style="background:blue !important;width:70px;color:#fff !important;border-bottom: 1px solid #fff !important;text-align:center;">{{ lang.update }}</td>
                                </tr>
                            </tbody>
                        </v-simple-table>
                    </v-col>
                </v-row>

                </template>
                <template #footer="" class="shadow">
                    <div class="d-flex text-light align-items-center px-3 py-2">
                    <b-button type="button" @click="addItem()" variant="success" class="ma-2" style="width:100px;">{{lang.save}}</b-button>
                    </div>
                </template>
            </b-sidebar>
            <vue-snotify></vue-snotify>
        </v-form>
    </div>
</template>

<script>
import axios from 'axios'
import {SnotifyPosition} from 'vue-snotify';
import SearchableSelect from '@/components/searchable-select.vue';

// Where the last category the user filed a product under is kept, so the next
// new product starts on the same one.
const LAST_CAT_KEY = 'ecar.lastProductCatId';
const LAST_CAT_TEXT_KEY = 'ecar.lastProductCatText';

const emptyInventoryProduct = () => ({
    id: 0,
    item_code: '',
    vendor_code: '',
    internal_code: '',
    barcode: '',
    mpn: '',
    gtin: '',
    brand_name: '',
    source_product_no: '',
    item_namear: '',
    item_nameen: '',
    def_descriptions: '',
    main_unit: 1,
    catid: 1,
    type: 1,
    taxids: '',
    storesids: '1,2',
    storesids_array: [],
    taxesArrays: [],
    item_type: 1,
    is_finalProduct: 1,
    status: 1,
    saleable: 1,
    can_be_returned: 1,
    branchesIds: [],
    branches_array: [],
});

const normalizeArrayField = (value) => {
    if (Array.isArray(value)) return value.filter((item) => item !== '');
    if (typeof value === 'string' && value.length > 0) return value.split(',').filter((item) => item !== '');
    return [];
};

export default{
    components: { SearchableSelect },
    data() {
        return {
            isEdit: 0,
            branch: {},
            taxes: [],
            item_code: '',
            productsname: [],
            product: emptyInventoryProduct(),
            categories: [],
            categoryText: '',
            loadingCats: false,
            catTotal: 0,
            catPageSize: 10,
            extra: {
                brand: 0,
            },
            productcats: [],
            alternatives: [],
            deftype: 1,
            units: [],
            finalsProd: [],
            priceLists: [],
            rawMaterials: [],
            taxesList: [],
            storesList: [],
            unitsPrices: {},
            branchesLists: [],
            product_settings: []
        }
    },
    methods: {
        getProductSettings()
        {
            this.product_settings = [];
            let cook = this.$cookies.get(this.$store.state.COOKIEPhase);
            const post = new FormData();
            post.append('defBranch',localStorage.getItem('defBranch'));
            post.append('financeYear',localStorage.getItem('financeYear'));
            post.append('type','getExtraSettings');
            post.append('auth',cook);
            post.append('lang',this.$cookies.get(this.$store.state.LangCooki));
            post.append('data[table]',"inventory_products")
            axios.post(
                this.$store.state.SAMCOTEC.r_path, post
            ).then((response) => {
                this.product_settings = response.data.results.data;

            });
        },
        addToBranches(id){
            let addMe = true;
            for(let i=0;i<this.product.branchesIds.length;i++){
                if(this.branch[`branch_`+id] === false){
                    if(id == this.product.branchesIds[i]){
                        this.product.branchesIds.splice(i,1);
                        addMe = false;
                    }
                }
            }
            if(addMe){
                this.product.branchesIds.push(id);
            }
        },
        updateThis(){
            const message = "تم التعديل بنجاح - لا تنسى ان تضغط زر حفظ حتى يتم اعتماد التعديل";
            this.$snotify.error(message, 'تنبيه', {
                timeout: 1000000,
                showProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                position: SnotifyPosition.centerCenter,
                buttons: [
                    {
                        text: this.lang.close,
                        action: (toast) => {
                            this.$snotify.remove(toast.id);
                        }
                    },
                ]
            });
            return false;
        },
        getUnits(){
            let cook = this.$cookies.get(this.$store.state.COOKIEPhase);
            const post = new FormData();
            post.append('defBranch',localStorage.getItem('defBranch'));
            post.append('financeYear',localStorage.getItem('financeYear'));
            post.append('type','getUnits');
            post.append('auth',cook);
            post.append('lang',this.$cookies.get(this.$store.state.LangCooki));
            post.append('data[units]',0)
            axios.post(
                this.$store.state.SAMCOTEC.r_path, post
            ).then((response) => {
                if(response && response.data && response.data.results){
                    this.units = response.data.results.data;
                }
            })
        },
        doconsole() {
            // // console.log("holaaaa",this.product);
        },
        changeTax(){
            let tax = '';
            if(this.product.isvat === true){
                tax = '1'
            }
            if(this.product.issmoke === true){
                // if(tax == '1'){
                //     tax = '1,2'
                //     tax = '1,2'
                // }else{
                //     tax = '2';
                // }
            }
            this.product.taxs = tax;
            this.CalckValues(1);
        },
        CalckValues(i){
            // // console.log(this.product);
            if(i==1){
                let vat = 0;
                let smoke = 0;
                if(this.product.isvat === true){
                    let t = this.$calcVat(this.product.price,2);
                    vat = t.vat;
                }
                // if(this.product.issmoke == true){
                //     smoke = this.product.price;
                // }
                this.product.taxprice = parseFloat(this.product.price) + parseFloat(vat) + parseFloat(smoke);

            }else{
                let value = 100;
                let vat = 0;
                let smoke = 0;
                if(this.product.isvat == true){
                    value = parseFloat(value) + 15;
                }
                // if(this.product.issmoke == true){
                //     value = parseFloat(value) + 100;
                // }
                const price = this.$calcTax(this.product.taxprice,value)

                this.product.price = price;
            }
        },
        /**
         * Categories are searched on the server, ten at a time. Nothing is
         * pre-selected here: that is resetAll()'s job for a new item and
         * getItem()'s for an existing one.
         */
        searchCategories(term){
            this.loadingCats = true;
            const post = new FormData();
            post.append('defBranch',localStorage.getItem('defBranch'));
            post.append('financeYear',localStorage.getItem('financeYear'));
            post.append("type","getPCatsList");
            post.append('auth',this.$cookies.get(this.$COOKIEPhase));
            post.append('data[id]',"all0");
            post.append('data[limit]',this.catPageSize);
            post.append('data[cpage]',0);
            post.append('data[search]',term || '');
            post.append('data[lang]',this.lang.langname);
            axios.post(
                this.$store.state.SAMCOTEC.r_path, post
            )
            .then((res) => {
                this.loadingCats = false;
                const results = (res.data && res.data.results) || {};
                const rows = results.data || [];
                this.catTotal = parseInt(results.allres || 0);

                let t = [];
                for(let i=0;i<rows.length;i++){
                    t.push({
                        text: this.lang.langname == 'en' ? (rows[i].nameen || rows[i].namear) : (rows[i].namear || rows[i].nameen),
                        value: rows[i].id
                    });
                }
                this.categories = t;
            })
            .catch(() => {
                this.loadingCats = false;
            });
        },
        onCategoryPicked(item){
            this.categoryText = item.text;
        },
        /**
         * Looks up the label for a category id that is not in the current page
         * of results - which is the normal case when editing an existing item.
         */
        resolveCategoryName(id){
            if(!id){
                this.categoryText = '';
                return;
            }
            const post = new FormData();
            post.append('defBranch',localStorage.getItem('defBranch'));
            post.append('financeYear',localStorage.getItem('financeYear'));
            post.append("type","getPCatsList");
            post.append('auth',this.$cookies.get(this.$COOKIEPhase));
            post.append('data[id]',"all");
            post.append('data[ids]',id);
            post.append('data[lang]',this.lang.langname);
            axios.post(
                this.$store.state.SAMCOTEC.r_path, post
            )
            .then((res) => {
                const rows = ((res.data && res.data.results) || {}).data || [];
                if(rows.length){
                    this.categoryText = this.lang.langname == 'en'
                        ? (rows[0].nameen || rows[0].namear)
                        : (rows[0].namear || rows[0].nameen);
                }else{
                    this.categoryText = '';
                }
            })
            .catch(() => { this.categoryText = ''; });
        },
        /**
         * Asks the server for the next free item code. `force` is the refresh
         * button; otherwise an existing value is left alone.
         */
        generateItemCode(force){
            if(this.isEdit == 1) return;
            if(!force && this.product.item_code) return;

            const post = new FormData();
            post.append('defBranch',localStorage.getItem('defBranch'));
            post.append('financeYear',localStorage.getItem('financeYear'));
            post.append("type","getNextItemCode");
            post.append('auth',this.$cookies.get(this.$COOKIEPhase));
            // The API rejects a request whose data bag is empty, so this is not
            // optional even though the endpoint takes no arguments.
            post.append('data[lang]',this.lang.langname);
            axios.post(
                this.$store.state.SAMCOTEC.r_path, post
            )
            .then((res) => {
                const code = (((res.data || {}).results || {}).data || {}).item_code;
                if(code && this.isEdit == 0){
                    this.product.item_code = code;
                }
            });
        },
        /**
         * @param {boolean} isNew  false when the caller is about to load an
         *   existing product, so no code is generated and no category restored.
         */
        resetAll(isNew){
            const fresh = isNew !== false;

            this.product = emptyInventoryProduct()
            this.unitsPrices = {}
            this.categoryText = ''
            this.searchCategories('');

            // When a product is about to be loaded, getItem() fetches the taxes
            // and the price table for that item code; firing a second, empty
            // request here would race it for unitsPrices.
            if(fresh){
                this.getTaxes();
            }

            if(fresh){
                // Start on the category the user last filed something under -
                // items are usually added in runs from the same category.
                const lastId = parseInt(localStorage.getItem(LAST_CAT_KEY) || 0);
                if(lastId){
                    this.product.catid = lastId;
                    const lastText = localStorage.getItem(LAST_CAT_TEXT_KEY) || '';
                    if(lastText){
                        this.categoryText = lastText;
                    }else{
                        this.resolveCategoryName(lastId);
                    }
                }else{
                    this.product.catid = 0;
                }

                this.generateItemCode(true);
            }
        },
        /**
         * Loads an existing item into the form as a brand new one: everything
         * that *describes* the product is kept (names, category, type, unit,
         * taxes, stores, branches, description, prices), everything that
         * *identifies* it is cleared and a fresh item code is generated.
         *
         * Clearing the code matters: the save endpoint looks the product up by
         * item_code and updates the match, so copying without a new code would
         * overwrite the original instead of creating a second item. The other
         * identifiers are cleared because the item lookup resolves a scan
         * against barcode / mpn / gtin / source no. as well, and duplicates
         * there would make a scanned code ambiguous.
         */
        copyFrom(itemcode){
            if(!itemcode) return;

            // getItem() only fills the form when it believes it is editing.
            this.isEdit = 1;
            this.resetAll(false);
            this.product.item_code = itemcode;

            this.getItem().then(() => {
                // getItem() leaves the code empty when nothing matched.
                if(!this.product.item_code){
                    this.isEdit = 0;
                    this.$snotify.error(
                        this.lang.langname == 'en'
                            ? 'That item could not be loaded'
                            : 'تعذر تحميل بيانات الصنف',
                        this.lang.alert || 'تنبيه',
                        {
                            timeout: 5000,
                            showProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            position: SnotifyPosition.centerCenter,
                        }
                    );
                    return;
                }

                this.product.id = 0;
                this.product.item_code = '';
                this.product.barcode = '';
                this.product.mpn = '';
                this.product.gtin = '';
                this.product.source_product_no = '';
                this.product.internal_code = '';

                const suffix = this.productLabels.copy_of;
                if(this.product.item_namear && suffix){
                    this.product.item_namear = `${this.product.item_namear} ${suffix}`;
                }
                if(this.product.item_nameen && suffix){
                    this.product.item_nameen = `${this.product.item_nameen} ${suffix}`;
                }

                // Back to "new item" before asking for the code: both the guard
                // in generateItemCode() and its callback refuse to touch the
                // field while isEdit is set.
                this.isEdit = 0;
                this.generateItemCode(true);
            });
        },
        /** Keeps the category the user just saved for the next new product. */
        rememberCategory(){
            if(this.product.catid){
                localStorage.setItem(LAST_CAT_KEY, this.product.catid);
                localStorage.setItem(LAST_CAT_TEXT_KEY, this.categoryText || '');
            }
        },
        getItem() {
            // // console.log("I am resting");
            const itemcode = this.product.item_code;
            const post = new FormData();
            post.append('defBranch',localStorage.getItem('defBranch'));
            post.append('financeYear',localStorage.getItem('financeYear'));
            post.append("type","getItemBycode");
            post.append("auth",this.$cookies.get(this.$store.state.COOKIEPhase));
            post.append("data[item_code]",itemcode);
            // Returned so callers can act once the product is in the form -
            // copying an item has to wait for it before clearing the identifiers.
            return axios.post(
                this.$store.state.SAMCOTEC.r_path, post
            ).then((response) => {
                const res = response.data;
                if(this.isEdit == 0) {
                    if(typeof res.results.data.id !== 'undefined' && res.results.data.length != 0){
                        this.product.item_code = '';
                        let message = "الصنف موجود مسبقا .. يرجى اضافة صنف اخر";
                        this.$snotify.error(message, 'تنبيه', {
                            timeout: 1000000,
                            showProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            position: SnotifyPosition.centerCenter,
                            buttons: [
                                {
                                    text: this.$parent.lang.close,
                                    action: (toast) => {
                                        this.$snotify.remove(toast.id);
                                    }
                                },
                            ]
                        });

                        return false;
                    }
                    return false;
                }
                    const loadedProduct = res.results.data || {};
                    this.product = Object.assign(emptyInventoryProduct(), loadedProduct, {
                        storesids_array: normalizeArrayField(loadedProduct.storesids_array || loadedProduct.stores),
                        taxesArrays: normalizeArrayField(loadedProduct.taxesArrays || loadedProduct.taxes),
                        branches_array: normalizeArrayField(loadedProduct.branches_array || loadedProduct.branches),
                        branchesIds: normalizeArrayField(loadedProduct.branches_array || loadedProduct.branches),
                        is_finalProduct: loadedProduct.is_finalProduct || loadedProduct.item_type || 1,
                        status: loadedProduct.status || 1,
                        saleable: loadedProduct.saleable || 1,
                    })
                    // The saved category is almost never inside the first page
                    // of picker results, so fetch its name explicitly.
                    this.resolveCategoryName(this.product.catid)

                    // Prices come from getTaxes(): getItemBycode returns them
                    // keyed by unit id with no unit names, which is not the shape
                    // the price table renders or the save endpoint reads.
                    // Returning it also means this method's promise only settles
                    // once the price table is populated.
                    return this.getTaxes()

            });
        },
        getAlternative(){
            const itemcode = this.item_code;
            const post = new FormData();
            post.append('defBranch',localStorage.getItem('defBranch'));
            post.append('financeYear',localStorage.getItem('financeYear'));
            post.append("type","getItemBycode");
            post.append("auth",this.$cookies.get(this.$store.state.COOKIEPhase));
            post.append("data[itemcode]",itemcode);
            axios.post(
                this.$store.state.SAMCOTEC.r_path, post
            ).then((response) => {
                const res = response.data;
                // // console.log(res);
                this.alternatives.push({
                    item_code: res.results.data.results[0].itemcode,
                    name: res.results.data.results[0].name,
                    price: res.results.data.results[0].price,
                    qty: res.results.data.results[0].qty,
                    cost: res.results.data.results[0].cost,
                });
                this.item_code = '';
            });
        },
        getTaxes(){
            const post = new FormData();
            post.append('defBranch',localStorage.getItem('defBranch'));
            post.append('financeYear',localStorage.getItem('financeYear'));
            post.append("type","taxesList");
            post.append("auth",this.$cookies.get(this.$store.state.COOKIEPhase));
            post.append("data[all]","1");
            post.append("data[item_code]",this.product.item_code);
            // Returned so a caller can wait for the price table to be in place.
            return axios.post(
                this.$store.state.SAMCOTEC.r_path, post
            ).then((response) => {
                if(response && response.data && response.data.results){
                    this.taxesList = response.data.results.data
                    this.storesList = response.data.results.storesList
                    this.branchesLists = response.data.results.branchesLists
                    this.unitsPrices = response.data.results.unitsPrices

                    for(let i=0;i<response.data.results.branchesLists;i++){
                        this.branch[`branch_`+response.data.results.branchesLists[i].id] = false;
                    }

                }
            });
        },
        getProducts(){
            const post = new FormData();
            post.append('defBranch',localStorage.getItem('defBranch'));
            post.append('financeYear',localStorage.getItem('financeYear'));
            post.append("type","getallproducts");
            post.append("auth",this.$cookies.get(this.$store.state.COOKIEPhase));
            post.append("data[all]","1");
            axios.post(
                this.$store.state.SAMCOTEC.r_path, post
            ).then((response) => {
                const res = response.data;
                // // console.log(res);
                if(res.results.data.length > 0){
                    for(let i=0;i<res.results.data.length;i++){
                        this.productsname.push(res.results.data[i])
                    }
                }
            });
        },
        addProd() {
            if(this.product.nameen == '' && this.product.name == ''){
                let message = "يرجى اضافة الاسم العربي للصنف";
                this.$snotify.error(message, 'تنبيه', {
                    timeout: 1000000,
                    showProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    position: SnotifyPosition.centerCenter,
                    buttons: [
                        {
                            text: this.$parent.lang.close,
                            action: (toast) => {
                                this.$snotify.remove(toast.id);
                            }
                        },
                    ]
                });
                this.invoice.payment.cash = this.full_ftotal
                return false;
            }
            else if(this.product.nameen != '' && this.product.name == ''){
                this.product.name = this.product.nameen
            }
            else if(this.product.name != '' && this.product.nameen == ''){
                this.product.nameen = this.product.name
            }
            const post = new FormData();
            post.append('defBranch',localStorage.getItem('defBranch'));
            post.append('financeYear',localStorage.getItem('financeYear'));
            post.append("type" , "addNewProduct");
            post.append("auth",this.$cookies.get(this.$store.state.COOKIEPhase));
            post.append("data[item_code]",this.product.item_code);

            post.append("data[item_code]",this.product.item_code);
            post.append("data[name]",this.product.name);
            post.append("data[nameen]",this.product.nameen);
            post.append("data[qty]",this.product.qty);
            post.append("data[price]",this.product.price);
            post.append("data[taxprice]",this.product.taxprice);
            post.append("data[type]",this.product.type);
            post.append("data[cost]",this.product.cost);
            post.append("data[catid]",this.product.catid);
            post.append("data[isvat]",this.product.isvat);
            post.append("data[issmoke]",this.product.issmoke);
            post.append("data[issmoke]",false);
            post.append("data[taxes]",this.product.taxes);
            post.append("data[product_type]",this.product.product_type);
            for(let i=0;i<this.alternatives.length;i++){
                post.append("data[alternatives]["+i+"]",this.alternatives[i].item_code);
            }
            axios.post(
                this.$store.state.SAMCOTEC.r_path , post
            )
            .then((response) => {
                let message = "تمت الاضافة - التعديل بنجاح";
                this.$snotify.error(message, 'تنبيه', {
                    timeout: 1000000,
                    showProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    position: SnotifyPosition.centerCenter,
                    buttons: [
                        {
                            text: this.$parent.lang.close,
                            action: (toast) => {
                                this.$snotify.remove(toast.id);
                            }
                        },
                    ]
                });
                const res = response.data;
                // // console.log("hello",res);
                document.getElementById('hidecrmprod').click();


            });
        },
        addItem(){
            // The category picker starts empty for the very first product, so
            // make sure one was chosen rather than filing the item under id 0.
            if(!this.product.catid){
                this.$snotify.error(
                    this.lang.langname == 'en'
                        ? 'Please choose a category for this item'
                        : 'يرجى اختيار قسم للصنف',
                    this.lang.alert || 'تنبيه',
                    {
                        timeout: 5000,
                        showProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        position: SnotifyPosition.centerCenter,
                    }
                );
                return false;
            }

            const post = new FormData();
            post.append('defBranch',localStorage.getItem('defBranch'));
            post.append('financeYear',localStorage.getItem('financeYear'));
            post.append("type","addProdItem");
            post.append("auth",this.$cookies.get(this.$store.state.COOKIEPhase));
            post.append('data[product]',JSON.stringify(this.product))
            post.append('data[salesTable]',JSON.stringify(this.unitsPrices[this.product.main_unit]))

            axios.post(
                this.$store.state.SAMCOTEC.r_path, post
            ).then(() => {
                document.getElementById('hidecrmprodaddedit').click();
                // Remember before the reset wipes the form, so the next new
                // product opens on this same category.
                this.rememberCategory();
                if (this.$parent && typeof this.$parent.getInvSettings === 'function') {
                    this.$parent.getInvSettings();
                }
                if (this.$parent && typeof this.$parent.getProducts === 'function') {
                    this.$parent.getProducts();
                }
                this.isEdit = 0;
                this.resetAll();
            })
        }
    },
    computed:{
        lang: function(){
            if(this.$cookies.get(this.$store.state.LangCooki) != null){
                if(this.$cookies.get(this.$store.state.LangCooki)  == 'en'){
                    return this.$store.state.lang.en;
                }else if(this.$cookies.get(this.$store.state.LangCooki)  == 'ur'){
                    return this.$store.state.lang.ur;
                }else{
                    return this.$store.state.lang.ar;
                }
            }
            else if(this.$store.state.deflang == 'en'){
                return this.$store.state.lang.en;
            }
            else if(this.$store.state.deflang == 'ur'){
                return this.$store.state.lang.ur;
            }else{
                return this.$store.state.lang.ar;
            }
        },
        branchesIList: function (){
            let t = []
            for (let i=0 ; i < this.branchesLists.length ; i++){
                t.push(
                    {
                        text: this.branchesLists[i][`name_${this.lang.langname}`],
                        value: this.branchesLists[i].id,
                    }
                )
            }
            return t;
        },
        storesIList: function (){
            let t = []
            for (let i=0 ; i < this.storesList.length ; i++){
                t.push(
                    {
                        text: this.storesList[i][`name_${this.lang.langname}`],
                        value: this.storesList[i].id,
                    }
                )
            }
            return t;
        },
        taxesIList: function (){
            let t = []
            for (let i=0 ; i < this.taxesList.length ; i++){
                t.push(
                    {
                        text: this.taxesList[i][`name${this.lang.langname}`],
                        value: this.taxesList[i].id,
                    }
                )
            }
            return t;
        },
        categoryHint: function(){
            if(this.catTotal > this.catPageSize){
                return `${this.productLabels.showing_first} ${this.catPageSize} ${this.productLabels.of} ${this.catTotal}`;
            }
            return '';
        },
        isFinal: function(){
            let t = [];
            t.push({
                text: this.lang.final_product,
                value: 1,
            })
            t.push({
                text: this.lang.raw_material,
                value: 2,
            })
            if(this.$store.state.licenseType.manafactoring_enable){
                t.push({
                    text: this.lang.factory_item,
                    value: 3,
                })
            }

            return t;
        },
        saleAbles: function(){
            let t = [];
            t.push({
                text: this.lang.salesable,
                value: 1,
            })
            t.push({
                text: this.lang.none_salesable,
                value: 2,
            })

            return t;
        },
        productLabels: function(){
            return {
                internal_code: this.lang.internal_code || 'Internal code',
                barcode: this.lang.barcode || 'Barcode',
                brand_name: this.lang.brand_name || this.lang.brand || 'Brand',
                source_product_no: this.lang.source_product_no || 'Source No.',
                def_descriptions: this.lang.def_descriptions || this.lang.description || 'Description',
                generate_code: this.lang.generate_code || 'Generate a new code',
                type_to_search: this.lang.type_to_search || 'Type to search...',
                searching: this.lang.searching || '...',
                no_results: this.lang.no_results || 'No results',
                showing_first: this.lang.showing_first || 'Showing first',
                of: this.lang.of || 'of',
                copy_of: this.lang.copy_of || (this.lang.langname == 'en' ? '(copy)' : '(نسخة)'),
            }
        },
        productstype: function(){
            return [
                {text: this.lang.inventory_item,value: 1},
                {text: this.lang.service_item,value: 2},
            ]
        },
        mainUnits: function(){
            let t = [];
            for(let i=0;i<this.units.length;i++){
                if(this.units[i].type == 1){
                    t.push({
                        text: this.units[i][`name`+this.lang.langname],
                        value: this.units[i].id
                    })
                }

            }
            return t;
        }
    },
    created() {
        this.getProductSettings();
        this.searchCategories('');
        this.getUnits();
    },
}
</script>

<style>
label{
    color:#000 !important;
}
.select_box{
  overflow: hidden;
  position: relative;
}
.select_box:after{
  width: 0;
  height: 0;
  border-right: 6px solid transparent;
  border-left: 6px solid transparent;
  border-top: 6px solid #fff;
  position: absolute;
  top: 60%;
  left: 30px;
  content: "";
  z-index: 500;
 }
.select_box select{
  width: 220px;
  border: 0;
  position: relative;
  z-index: 99;
}
</style>
